import { createContext, useContext } from 'react';

export type ScrollAreaContextProps = {
  visible?: boolean;
};
export const ScrollAreaContext = createContext<ScrollAreaContextProps>({
  visible: true,
});
ScrollAreaContext.displayName = 'ScrollAreaContext';

const useScrollAreaContext = () => useContext(ScrollAreaContext);

export default useScrollAreaContext;
